module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.58b1f440.ttf";